import React from 'react';
import BadgeBase, { TBadge } from './BadgeBase';
import { BadgeSignals } from '../../types/TEBadgeSignal';

const NeutralInverse = (props: Omit<TBadge, 'signal'>) => <BadgeBase {...props} signal={BadgeSignals.NeutralInverse} />;

export default NeutralInverse;
